import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  uomTabTitle: {
    description: 'Tab title for the Units of Measure tab in product details',
    defaultMessage: 'Units of Measure',
    id: 'lvmW/r',
  },
  uomConfigurationTitle: {
    description: 'Unit configuration card title',
    defaultMessage: 'Units of Measure',
    id: 'eD/H5z',
  },
  uomConfigurationSubtitle: {
    description: 'Unit configuration card subtitle',
    defaultMessage:
      'Manage pack, case, and pallet configurations to streamline inventory receiving and barcode scanning across your warehouses.',
    id: 'B2bcFf',
  },
  uomPrintBarcodes: {
    description: 'Print Barcodes button',
    defaultMessage: 'Print Barcodes',
    id: 'V9C0ne',
  },
  uomHeaderType: {
    description: 'UoM grid header - type (unit name from lookup)',
    defaultMessage: 'Type',
    id: 'PBH1D5',
  },
  uomHeaderQuantity: {
    description: 'UoM grid header - quantity (conversion factor)',
    defaultMessage: 'Quantity',
    id: 'TP3CKJ',
  },
  uomHeaderBarcode: {
    description: 'UoM grid header - barcode',
    defaultMessage: 'Barcode',
    id: 'icIs6G',
  },
  uomHeaderUomSku: {
    description: 'UoM grid header - UoM SKU',
    defaultMessage: 'UoM SKU',
    id: 'XZTIVG',
  },
  uomHeaderDimensions: {
    description: 'UoM grid header - dimensions',
    defaultMessage: 'Dimensions',
    id: 'XT0H5v',
  },
  uomHeaderWeight: {
    description: 'UoM grid header - weight',
    defaultMessage: 'Weight',
    id: 'CMehl0',
  },
  uomHeaderStackable: {
    description: 'UoM grid header - stackable',
    defaultMessage: 'Stackable',
    id: 'WWtx89',
  },
  uomAddUnit: {
    description: 'Add unit inline button',
    defaultMessage: 'Add unit',
    id: '7DDnaM',
  },
  uomConversionSummaryTitle: {
    description: 'Conversion summary section title',
    defaultMessage: 'Conversion Summary',
    id: 'PM41t5',
  },
  uomRowEdit: {
    description: 'Row action: edit',
    defaultMessage: 'Edit',
    id: 'sTagcm',
  },
  uomRowDelete: {
    description: 'Row action: delete',
    defaultMessage: 'Delete',
    id: '+33km7',
  },
  uomLoadingError: {
    description: 'UoM loading error',
    defaultMessage: 'Failed to load units of measure.',
    id: '0yBNDX',
  },
  uomDeleteConfirmTitle: {
    description: 'Delete UoM confirmation modal title',
    defaultMessage: 'Delete Unit of Measure',
    id: 'NXyLJ8',
  },
  uomDeleteConfirmBody: {
    description: 'Delete UoM confirmation modal body text',
    defaultMessage: 'Are you sure you want to delete this unit of measure? This action cannot be undone.',
    id: 'EXCL9j',
  },
  uomDeleteConfirmAction: {
    description: 'Delete UoM confirmation modal delete button',
    defaultMessage: 'Delete',
    id: '7zYBRB',
  },
  uomDeleteConfirmCancel: {
    description: 'Delete UoM confirmation modal cancel button',
    defaultMessage: 'Cancel',
    id: 'U2ysHy',
  },
  uomStackableYes: {
    description: 'UoM grid stackable column - yes',
    defaultMessage: 'Yes',
    id: '7U2igs',
  },
  uomStackableNo: {
    description: 'UoM grid stackable column - no',
    defaultMessage: 'No',
    id: 'xf7tA6',
  },
  uomSaveError: {
    description: 'UoM save error notification',
    defaultMessage: 'Failed to save unit of measure.',
    id: 'R/TwKL',
  },
  uomSaveBarcodeConflict: {
    description: 'UoM save error notification when the barcode is already used by another product',
    defaultMessage: 'Barcode "{barcode}" is already used by another product. Please choose a different barcode.',
    id: 'C7D7y9',
  },
  uomSaveSuccess: {
    description: 'UoM save success notification',
    defaultMessage: '{typeName} saved.',
    id: '6PgUMV',
  },
  uomAddSuccess: {
    description: 'UoM add success notification shown after a new unit of measure is created',
    defaultMessage: 'Unit of Measure {typeName} was saved successfully',
    id: '2jQp1o',
  },
  uomEditSuccess: {
    description: 'UoM edit success notification shown after an existing unit of measure is updated',
    defaultMessage: 'Unit of Measure {typeName} was updated successfully',
    id: 'kVjXkW',
  },
  uomDeleteError: {
    description: 'UoM delete error notification',
    defaultMessage: 'Failed to delete unit of measure.',
    id: 'geRmzH',
  },
  uomDeleteBlockedTitle: {
    description: 'UoM delete blocked modal title',
    defaultMessage: 'Cannot delete unit of measure',
    id: 'qqT+Da',
  },
  uomDeleteBlockedDismiss: {
    description: 'UoM delete blocked modal dismiss button',
    defaultMessage: 'Close',
    id: 'T8W0L5',
  },
  uomDeleteBlockedSubtitleChain: {
    description: 'UoM delete blocked subtitle when unit is part of a chain',
    defaultMessage: '{unitName} · {quantity} {parentName} is part of a UoM chain',
    id: 'UzeH6z',
  },
  uomDeleteBlockedByChain: {
    description: 'UoM delete blocked because unit is part of a chain',
    defaultMessage: 'This unit of measure cannot be deleted because it is included in an additional unit of measure.',
    id: 'x2xjhn',
  },
  uomDeleteBlockedUsedBy: {
    description: 'UoM delete blocked used by label',
    defaultMessage: 'Used by:',
    id: '1KtPhc',
  },
});
